import { Formik, Form, Field, ErrorMessage, FieldArray } from 'formik';
import React, { Fragment } from 'react'
import { useEffect } from 'react';
import { withRouter } from 'react-router-dom'
import estilos from '../../../../UsuarioInspectorEnCampo/Asociados/Tabs/TabsInspeccionarComponent.module.css'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';

import { getElementoSeccionByIdArea } from '../../../../../redux/DucksUnidadInspeccion/ElementoSeccionDuck';
import { getProcesoByIdArea } from '../../../../../redux/DucksUnidadInspeccion/ProcesosDuck';

import { Store } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css'
import { gridColumnVisibilityModelSelector } from '@mui/x-data-grid';
import { obtenerInformesByIdInstalacion } from '../../../../../redux/DucksUnidadInspeccion/DocumentosDuck';


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 1300,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

function DestilacionFormComponent(props) {

    const dispatch = useDispatch();

    const tipoequipo = useSelector(store => store.ElementoSeccion.ElementoSeccion);
    //const procesos = useSelector(store => store.Procesos.Proceso);

    const [procesos, setProcesos] = React.useState([]);
    const [docinformePasado, setDocinformePasado] = React.useState();
    const [informacionFormik, setInformacionFormik] = React.useState(
        {
            cantidad: '',
            capacidad: '',
            descripcion: '',
            condicion: '',
            largo: '',
            ancho: '',
            area: ''
        }
    );

    const [equipoDestilacion, setequipoDestilacion] = React.useState([]);
    const [procesosDestilacion, setProcesosDestilacion] = React.useState([]);

    const [docinforme, setDocInforme] = React.useState();

    //const initialValues = {
    //    equipoDestilacion
    //};

    const [initialValues, setInitialValues] = React.useState({
        directo: '',
        indirecto: '',
        equipoDestilacion: equipoDestilacion,
        procesosDestilacion: procesosDestilacion,
        largo: 0,
        ancho: 0,
        area: 0
    })



    const [informacionFormikModal, setInformacionFormikModal] = React.useState(
        {
            tipo: '',
            cantidad: '',
            capacidad: '',
            descripcion: '',
            condicion: '',
            largo: '',
            ancho: '',
            area: ''
        }
    );



    const [openModalNuevoEquipo, setOpenModalNuevoEquipo] = React.useState(false);

    const [editarEquipo, setEditarEquipo] = React.useState(true);

    useEffect(() => {

        console.log(props.informe)

        const equipo = props.informe.fi_25_anexo[0].fi_25_anexo_equipo_historial.filter(e => e.elemento.elementosdeseccion[0].idseccion == 4)

        setequipoDestilacion(equipo)

        dispatch(obtenerInformesByIdInstalacion(props.informe.informaciongeneralinstalacioncliente.idiformaciongeneralcliente)).then((r) => {
            console.log(r.payload.data.data)
            setDocInforme(r.payload.data.data)
        })

        dispatch(getElementoSeccionByIdArea(4))
        dispatch(getProcesoByIdArea(4)).then((res) => {
            setProcesos(res.payload.data.data)
        })

    }, [])

    const handleModificar = () => {
        setEditarEquipo(!editarEquipo);
    }

    const handleOpenModalNuevoEquipo = () => {
        setOpenModalNuevoEquipo(true);
    }
    const handleCloseModalNuevoEquipo = () => {
        setOpenModalNuevoEquipo(false);
    }

    useEffect(() => {
        initialValues
    }, [initialValues])

    const handleNuevoEquipo = (valores) => {

        let equipoSeleccionado = tipoequipo.filter((t) => valores.tipo == t.idelemento)

        setequipoDestilacion([...equipoDestilacion, {
            cantidad: valores.cantidad,
            capacidad: valores.capacidad,
            condicion: valores.condicion,
            descripcion: valores.descripcion,
            elemento: {
                idelemento: valores.tipo,
                tipoOtros: valores.tipoOtros,
                nombreelemento: equipoSeleccionado[0].elemento.nombreelemento
            },
            //idanexocliente: 1,
            //iddataelemntocliente: 1,
            //idseccion: 1,
            otro: null
        }])

        handleCloseModalNuevoEquipo();
    }

    useEffect(() => {
        let sup = props.informe.fi_25_anexo[0].superficie.filter(s => s.idseccion == 4);

        setInitialValues({
            equipoDestilacion: equipoDestilacion,
            procesosDestilacion: procesosDestilacion,
            largo: sup[0].largo,
            ancho: sup[0].ancho,
            area: sup[0].area,
            categoria: docinforme.categoriamezcal
        })
    }, [equipoDestilacion, procesosDestilacion])

    const handleEliminarEquipo = (elemento) => {
        let nuevoEquipo = equipoDestilacion.filter((equipo) => equipo !== elemento);
        setequipoDestilacion(nuevoEquipo);
    }

    useEffect(() => {
        let aux = []
        props.informe.fi_25_anexo[0].fi_25_anexo_procesos.forEach((e) => {
            procesos.forEach(element => {
                if (element.idseccion == 4) {
                    if (e.idproceso == element.idproceso) {
                        if (!procesosDestilacion.includes(element)) {
                            aux.push(e)
                        }
                    }
                }
            })
        })
        setProcesosDestilacion(aux)

    }, [procesos])

    useEffect(() => {
        procesosDestilacion
    }, [procesosDestilacion])


    const modalNuevoEquipo = () => {
        return (
            <div>
                <Modal
                    open={openModalNuevoEquipo}
                    onClose={handleCloseModalNuevoEquipo}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <div style={{ textAlign: "center" }}>
                                Nuevo Equipo
                            </div>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }}>
                            <Formik
                                initialValues={informacionFormikModal}
                                onSubmit={(valores) => {
                                    handleNuevoEquipo(valores)
                                }}
                            >
                                {(props) => (
                                    <Form>
                                        <div className='table-responsive'>
                                            <table className='table table-striped table-hover'>
                                                <thead>
                                                    <tr>
                                                        <th>Tipo</th>
                                                        <th>Cantidad</th>
                                                        <th>Capacidad (L)</th>
                                                        <th>Descripción y/o características</th>
                                                        <th width="120">Condición</th>
                                                        {//<th>Largo (m)</th>
                                                            //<th>Ancho (m)</th>
                                                            //<th>Área (m²)</th>
                                                        }
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <Field
                                                                component="select"
                                                                id="tipo"
                                                                name="tipo"
                                                                className="form-select"
                                                                multiple={false}
                                                                required
                                                            >
                                                                <option defaultValue>Seleccione Tipo de Equipo</option>
                                                                {tipoequipo.map((t, index) => (
                                                                    <option key={index} value={t.idelemento}>{t.elemento.nombreelemento}</option>
                                                                ))}
                                                            </Field>
                                                            {
                                                                props.values.tipo === "4" ?
                                                                    <div>
                                                                        <br />
                                                                        <label htmlFor='tipoOtros'>Tipo de equipo:</label>
                                                                        <Field
                                                                            type="text"
                                                                            id="tipoOtros"
                                                                            name="tipoOtros"
                                                                            className="form-control form-control-sm"
                                                                        />
                                                                    </div>
                                                                    : <div></div>
                                                            }
                                                        </td>
                                                        <td><Field type="text" className="form-control form-control-sm" id="cantidad" name="cantidad" placeholder="Cantidad" required /></td>
                                                        <td><Field type="text" className="form-control form-control-sm" id="capacidad" name="capacidad" placeholder="Capacidad" required /></td>
                                                        <td><Field type="text" className="form-control form-control-sm" id="descripcion" name="descripcion" placeholder="Descripción" required /></td>
                                                        <td>
                                                            <Field
                                                                component="select"
                                                                id="condicion"
                                                                name="condicion"
                                                                className="form-select"
                                                                multiple={false}
                                                                required

                                                            >
                                                                <option defaultValue>Seleccione Condicion</option>
                                                                <option value={"Buena"}>Buena</option>
                                                                <option value={"Regular"}>Regular</option>
                                                                <option value={"Mala"}>Mala</option>
                                                            </Field>
                                                        </td>
                                                        {//<td><Field type="text" className="form-control form-control-sm" id="largo" name="largo" placeholder="Largo" onChange={handleObtenerLargo} value={superficie.largo} required /></td>
                                                        }
                                                        {//<td><Field type="text" className="form-control form-control-sm" id="ancho" name="ancho" placeholder="Ancho" onChange={handleObtenerAncho} value={superficie.ancho} required /></td>
                                                        }
                                                        {//<td><Field type="text" className="form-control form-control-sm" id="area" name="area" placeholder="Área" value={superficie.area} required /></td>
                                                        }
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div style={{ textAlign: "center" }}>
                                            <button type='submit' className="btn btn-success">GUARDAR</button>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </Typography>
                        <br />

                    </Box>
                </Modal>
            </div>
        )
    }

    return (
        <Fragment>
            <Formik
                initialValues={initialValues}
                enableReinitialize={true}
                validate={(valores) => {

                }}
                onSubmit={(valores) => {



                    Store.addNotification({
                        title: "Destilación!",
                        message: "Guardado Correctamente",
                        type: "success",
                        insert: "top",
                        container: "top-center",
                        animationIn: ["animate__animated", "animate__fadeIn"],
                        animationOut: ["animate__animated", "animate__fadeOut"],
                        dismiss: {
                            duration: 3000,
                            onScreen: true
                        }
                    });



                }}
            >
                {({ values }) => (
                    <Form>
                        {/* <div className='row'>
                             <label className={`${estilos.labelUI_title} mb-2`}>DESTILACIÓN</label>
                        </div>
                        */}
                        <div className={`${estilos.labelUI} row mb-2`}>
                            <label className={`${estilos.labelUI} mb-2`}>Superficie:</label>
                        </div>
                        <div className='row'>
                            <div className="col-md-3 mb-3">
                            </div>
                            <div className="col-md-2 mb-3">
                                <label htmlFor="largo">Largo (m)</label>
                                <Field type="text" className="form-control form-control-sm" id="largo" name="largo" placeholder="Largo" required />
                            </div>
                            <div className="col-md-2 mb-3">
                                <label htmlFor="ancho">Ancho (m)</label>
                                <Field type="text" className="form-control form-control-sm" id="ancho" name="ancho" placeholder="Ancho" required />
                            </div>

                            <div className="col-md-2 mb-3">
                                <label htmlFor="area">Área (m²)</label>
                                <Field type="text" className="form-control form-control-sm" id="area" name="area" placeholder="Área" value={values.largo * values.ancho} required />
                            </div>
                        </div>
                        <hr />
                        <div className={`${estilos.labelUI} row mb-2`}>
                            <div className='col-md-5 mb-3'>
                                <label className={`${estilos.labelUI} mb-2`}>Forma de calentamiento:</label>
                            </div>
                            <div className="col-md-3 mb-3">
                                <label htmlFor='directo'>
                                    <Field className="form-check-input" type="checkbox" name="directo" id="directo" />
                                    <br />
                                    <div className='text-white'>Directo</div>
                                </label>

                            </div>
                            <div className="col-md-3 mb-3">
                                <label htmlFor="indirecto">
                                    <Field className="form-check-input" type="checkbox" name="indirecto" id="indirecto" />
                                    <br />
                                    <div className='text-white'>Indirecto</div>
                                </label>
                            </div>
                        </div>
                        <div className='table-responsive'>
                            <table className='table table-striped table-hover'>
                                <thead>
                                    <tr>
                                        <th>Tipo</th>
                                        <th>Cantidad</th>
                                        <th>Capacidad (L)</th>
                                        <th>Descripción y/o características</th>
                                        <th width="120">Condición</th>
                                        {//<th>Largo (m)</th>
                                            //<th>Ancho (m)</th>
                                            //<th>Área (m²)</th>
                                        }
                                        <th>Acciones</th>
                                        <th>Validar</th>
                                    </tr>
                                </thead>
                                <FieldArray
                                    name='equipoDestilacion'
                                    render={arrayHelpers => (
                                        <tbody>
                                            {equipoDestilacion &&
                                                equipoDestilacion.map((equipo, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            {equipo.elemento.nombreelemento}
                                                            <h6>{equipo.elemento.tipoOtros}</h6>
                                                        </td>
                                                        <td><Field type="text" className="form-control form-control-sm" id="cantidad" name={`equipoDestilacion.${index}.cantidad`} placeholder="Cantidad" required disabled={editarEquipo} /></td>
                                                        <td><Field type="text" className="form-control form-control-sm" id="capacidad" name={`equipoDestilacion.${index}.capacidad`} placeholder="Capacidad" required disabled={editarEquipo} /></td>
                                                        <td><Field type="text" className="form-control form-control-sm" id="descripcion" name={`equipoDestilacion.${index}.descripcion`} placeholder="Descripción" required disabled={editarEquipo} /></td>
                                                        <td>
                                                            <Field
                                                                component="select"
                                                                id="condicion"
                                                                name={`equipoDestilacion.${index}.condicion`}
                                                                className="form-select"
                                                                multiple={false}
                                                                disabled={editarEquipo}
                                                            >
                                                                <option defaultValue>Seleccione Condicion</option>
                                                                <option value={"Buena"}>Buena</option>
                                                                <option value={"Regular"}>Regular</option>
                                                                <option value={"Mala"}>Mala</option>
                                                            </Field>
                                                        </td>
                                                        {
                                                            //<td><Field type="text" className="form-control form-control-sm" id="largo" name={`equipoDestilacion.${index}.largo`} placeholder="Largo" disabled={editarEquipo} required /></td>
                                                            //<td><Field type="text" className="form-control form-control-sm" id="ancho" name={`equipoDestilacion.${index}.ancho`} placeholder="Ancho" disabled={editarEquipo} required /></td>
                                                            //<td><Field type="text" className="form-control form-control-sm" id="area" name={`equipoDestilacion.${index}.area`} placeholder="Área" value={superficie.area} disabled={editarEquipo} required /></td>
                                                        }
                                                        <td><button type="button" className='btn btn-warning btn-sm' onClick={() => handleModificar()}>Modificar</button> <hr /> <button type="button" className='btn btn-danger btn-sm' onClick={() => handleEliminarEquipo(equipo)}>Eliminar</button></td>
                                                        <td><Field className="form-check-input" type="checkbox" name={`equipoDestilacion.${index}.validar`} id="validar" /></td>
                                                    </tr>
                                                ))}
                                        </tbody>
                                    )}
                                />
                            </table>
                        </div>
                        <br />
                        <div style={{ textAlign: "center" }}>
                            <button type="button" className={`btn ${estilos.botonCircular}`} onClick={handleOpenModalNuevoEquipo}>+</button> Añadir nuevo equipo
                        </div>
                        <br />
                        <div className='row'>
                            <label className={`${estilos.labelUI} mb-2`}>MÉTODO</label>
                        </div>
                        <div className='row'>
                            <div className="col-md-4 mb-3">
                                <label htmlFor="">PROCESO</label>
                            </div>
                            <div className="col-md-8 mb-3">
                                <label htmlFor="">DESCRIPCIÓN</label>
                            </div>
                        </div>
                        <FieldArray
                            name='procesosDestilacion'
                            render={arrayHelpers => (
                                <div>
                                    {procesosDestilacion.map((p, index) => (
                                        <div key={index}>
                                            <div className='row'>
                                                <div className="col-md-4 mb-3">
                                                    <label htmlFor={`procesosDestilacion.${index}`}>{p.procesos.descripcion}</label>
                                                </div>
                                                <div className="col-md-8 mb-3">
                                                    <Field type="text" className="form-control form-control-sm" id={`procesosDestilacion.${index}`} name={`procesosDestilacion.${index}.comentarios`} placeholder={p.procesos.descripcion} required />
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        />


                        <hr></hr>


                        <hr />
                        <div style={{ textAlign: "center" }}>
                            <div className='row'>
                                <label className={`${estilos.labelUI} mb-2`}>DEFINICIÓN DE CATEGORÍA</label>
                            </div>

                            <div style={{ textAlign: "center" }}>
                                <p style={{ textAlign: "center" }}>Mediante la constatación física de las instalaciones antes descritas y con la información aportada por el productor de Mezcal de
                                    la empresa al momento de su entrevista, se recabo la evidencia necesaria para establecer que esta unidad de producción</p>
                                <center>
                                    <Field
                                        component="select"
                                        id="cumple"
                                        name="cumple"
                                        className="form-select form-select-sm"
                                        multiple={false}
                                        style={{ width: 100 }}
                                    >
                                        { }
                                        <option defaultValue>...</option>
                                        <option value={1} >SI</option>
                                        <option value={2} >NO</option>

                                    </Field>
                                </center>
                                <p>cumple con el apartado 4.4. de la NOM-070-SCFI-2016  y elabora Mezcal en la categoría:</p>
                                <center>
                                    <Field
                                        component="select"
                                        id="categoria"
                                        name="categoria"
                                        className="form-select form-select-sm"
                                        multiple={false}
                                        style={{ width: 200 }}
                                    >
                                        <option defaultValue>...</option>
                                        <option value={'MEZCAL'} >MEZCAL</option>
                                        <option value={'MEZCAL ANCESTRAL'} >MEZCAL ANCESTRAL</option>
                                        <option value={'MEZCAL ARTESANAL'} >MEZCAL ARTESANAL</option>
                                    </Field>
                                </center>
                                <br />
                            </div>
                            <div className='row'>
                                <div className="row mb-5">
                                    <div className="col ">
                                        <button className={`btn ${estilos.botonVerdeCOMERCAM}`} type='submit'>GUARDAR</button>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </Form>
                )}
            </Formik>

            <div>
                {modalNuevoEquipo()}
            </div>
            <hr />
        </Fragment>
    );
};


export default withRouter(DestilacionFormComponent)
